module.exports = __webpack_public_path__ + "static/faq-image.31215f17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/faq-image.svg
// module id = 494
// module chunks = 87192162464282